'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = undefined;
exports["default"] = Application;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles/rainbow-styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _React$createContext = _react2["default"].createContext(),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;
/**
 * This component is used to setup the React Rainbow context for a tree.
 * Usually, this component will wrap an app's root component so that the entire
 * app will be within the configured context.
 * @category Layout
 */


exports.Provider = Provider;
exports.Consumer = Consumer;

function Application(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  return _react2["default"].createElement(Provider, null, _react2["default"].createElement('div', {
    className: className,
    style: style
  }, children));
}

Application.propTypes = {
  /**
   * This prop should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2["default"].oneOfType([_propTypes2["default"].arrayOf(_propTypes2["default"].node), _propTypes2["default"].object]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2["default"].object
};
Application.defaultProps = {
  children: [],
  className: undefined,
  style: undefined
};